import gql from 'graphql-tag';

export const query = gql`
  query GetFaculties($uniId: Int!, $eduTag: String) {
    university(id: $uniId) {
      id
      name
      engVeryShortName
      color
      faculties(eduTag: $eduTag) {
        id
        name
        logo
      }
    }
  }
`;

export const converter = (fac = {}) => ({
  id: fac.id,
  title: fac.name,
  avatarImage: fac.logo,
});

export const converter2 = universityId => (fac = {}) => ({
  id: `${universityId}:${fac.id}`,
  title: fac.name,
  avatarImage: fac.logo,
});

export const getFacultyInfo = (universityId, facultyId) => {
  const { data } = require(`../../data/university/${universityId}.json`);
  const { university } = data;
  const facultyDetail = university.faculties.find(faculty => faculty.id === facultyId);
  return {
    id: facultyId,
    name: facultyDetail.name,
    logo: facultyDetail.logo,
    tagId: facultyDetail.tagId,
    university: {
      id: universityId,
      name: university.name,
    },
  };
};
